import { engineComponent, ArrayUtils } from "neo-common";
import { BaseController } from "./BaseController";
import { Paylines } from "../Paylines";
import { Symbols } from "../Symbols";
import { Machine } from "../Machine";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { GameManager } from "../../Managers/GameManager";
import { FrameTimerEventEmitter, CreateFrameTimer, FrameTimerEvents } from "../../Utils/FrameTimer";
import { PlayList } from "../../Components/Sounds/PlayList";
import { DataManager } from "../../Managers/DataManager";
import { StageController } from "../../Components/StageController";
import { ModuleManager } from "../../Managers/ModuleManager";
import { WinAnimatorExtended } from "../../CustomComponents/WinAnimatorExtended";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { WinAnimator } from "../WinAnimator";
import { CustomEase } from "../../Components/Effects/CustomEase";
import { Tweens } from "../../Components/Effects/Tweens";
import { MachineExtended } from "../../CustomComponents/MachineExtended";
import { TeasingExtended } from "../../CustomComponents/TeasingExtended";

@engineComponent(ComponentTypes.DisplayObject)
export class BaseView extends ContainerElement {
    private _controller: BaseController;
    private _wasFinished: boolean = false;
    private _introDelay: FrameTimerEventEmitter;
    private _outroDelay: FrameTimerEventEmitter;

    private _paylines: Paylines;
    private _symbols: Symbols;
    private _machine: MachineExtended;
    private _winAnimator: WinAnimatorExtended;

    /**** CUSTOM ******/
    private isForce: boolean = false;

    private _toGambleDelay: FrameTimerEventEmitter;
    private _changeJackDelay: FrameTimerEventEmitter;
    private _teasing: SwitchElement;
    private teasingFS: SwitchElement;
    private teasingBonus: SwitchElement;
    private winframes: ContainerElement;
    private specialMachine: ContainerElement;
    private machineTop: ContainerElement;
    private fireflies: ContainerElement;
    private background: ContainerElement;
    private teasingEyesContainer: ContainerElement;
    private paylinesContainer: ContainerElement;
    private messageContainer: ContainerElement;
    private transitionScreenContainer: ContainerElement;
    private jackContainer: ContainerElement;
    private foregroundContainer: ContainerElement;
    private logoContainer: ContainerElement;

    private _teasingExtended: TeasingExtended;

    public static Background: SwitchElement;
    public static TeasingEyes: SwitchElement;
    public static TransitionScreen: SwitchElement;
    public static Jack: SwitchElement;
    public static FireFlies: SwitchElement;
    public static MachineTop: SwitchElement;
    public static PaylinesContainer: Paylines;
    public static Message: SwitchElement;
    public static Foreground: SwitchElement;
    public static OutroFrom: string;
    public static Logo: SwitchElement;

    constructor() {
        super();

        this._introDelay = CreateFrameTimer("introDelay");
        this._introDelay.on(FrameTimerEvents.Complete, this.introFinished.bind(this));

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        this._toGambleDelay = CreateFrameTimer("toGambleDelay");
        this._toGambleDelay.on(FrameTimerEvents.Complete, this.toGambleTransition.bind(this));

        this._changeJackDelay = CreateFrameTimer("changeJackDelay");
        this._changeJackDelay.on(FrameTimerEvents.Complete, this.changeJackDelay.bind(this));

        StageController.baseStageContainer = this;

        CustomEase._createOwnEasing();

        this._teasingExtended = new TeasingExtended();

        BaseView.OutroFrom = "BASE";
    }

    createByNode(node: Element): void {
        super.createByNode(node);

        if (this.childs != null) {
            for (let key in this.childs) {
                if (this.childs[key] instanceof Paylines) {
                    this._paylines = this.childs[key];
                    BaseView.PaylinesContainer = this.childs[key];
                }

                if (this.childs[key] instanceof Symbols) {
                    this._symbols = this.childs[key];
                    this.removeChild(this._symbols);
                }

                if (this.childs[key] instanceof Machine) {
                    this._machine = this.childs[key];
                }

                if (this.childs[key] instanceof WinAnimator) {
                    this._winAnimator = this.childs[key];
                }

                if (key === "Teasing" && this.childs[key] instanceof SwitchElement) {
                    this._teasing = this.childs[key];
                }

                if (key === "TeasingFS" && this.childs[key] instanceof SwitchElement) {
                    this.teasingFS = this.childs[key];
                }

                if (key === "TeasingBonus" && this.childs[key] instanceof SwitchElement) {
                    this.teasingBonus = this.childs[key];
                }

                if (key === "WinFrames" && this.childs[key] instanceof ContainerElement) {
                    this.winframes = this.childs[key];
                }

                if (key === "SpecialMachine" && this.childs[key] instanceof ContainerElement) {
                    this.specialMachine = this.childs[key];
                }

                if (key === "MachineTopBase" && this.childs[key] instanceof ContainerElement) {
                    this.machineTop = this.childs[key];
                }

                if (key === "BackgroundBase" && this.childs[key] instanceof ContainerElement) {
                    this.background = this.childs[key];
                }

                if (key === "TeasingEyesContainer" && this.childs[key] instanceof ContainerElement) {
                    this.teasingEyesContainer = this.childs[key];
                }

                if (key === "FirefliesBase" && this.childs[key] instanceof ContainerElement) {
                    this.fireflies = this.childs[key];
                }

                if (key === "PaylinesContainer" && this.childs[key] instanceof ContainerElement) {
                    this.paylinesContainer = this.childs[key];
                    this.paylinesContainer.addChild(BaseView.PaylinesContainer);
                }

                if (key === "MessageContainer" && this.childs[key] instanceof ContainerElement) {
                    this.messageContainer = this.childs[key];
                }

                if (key === "TransitionScreenContainer" && this.childs[key] instanceof ContainerElement) {
                    this.transitionScreenContainer = this.childs[key];
                }

                if (key === "JackContainer" && this.childs[key] instanceof ContainerElement) {
                    this.jackContainer = this.childs[key];
                }

                if (key === "ForegroundContainer" && this.childs[key] instanceof ContainerElement) {
                    this.foregroundContainer = this.childs[key];
                }

                if (key === "LogoContainer" && this.childs[key] instanceof ContainerElement) {
                    this.logoContainer = this.childs[key];
                }

                /*
                 * SHARED COMPONENTS
                 */
                if (key === "MachineTop" && this.childs[key] instanceof SwitchElement) {
                    BaseView.MachineTop = this.childs[key];
                    this.machineTop.addChild(BaseView.MachineTop);
                }

                if (key === "Background" && this.childs[key] instanceof SwitchElement) {
                    BaseView.Background = this.childs[key];
                    this.background.addChild(BaseView.Background);
                }

                if (key === "TeasingEyes" && this.childs[key] instanceof SwitchElement) {
                    BaseView.TeasingEyes = this.childs[key];
                    this.teasingEyesContainer.addChild(BaseView.TeasingEyes);
                }

                if (key === "FireFlies" && this.childs[key] instanceof SwitchElement) {
                    BaseView.FireFlies = this.childs[key];
                    this.fireflies.addChild(BaseView.FireFlies);
                }

                if (key === "Message" && this.childs[key] instanceof SwitchElement) {
                    BaseView.Message = this.childs[key];
                    this.messageContainer.addChild(BaseView.Message);
                }

                if (key === "TransitionScreen" && this.childs[key] instanceof SwitchElement) {
                    BaseView.TransitionScreen = this.childs[key];
                    this.transitionScreenContainer.addChild(BaseView.TransitionScreen);
                }

                if (key === "Jack" && this.childs[key] instanceof SwitchElement) {
                    BaseView.Jack = this.childs[key];
                    this.jackContainer.addChild(BaseView.Jack);
                }

                if (key === "Foreground" && this.childs[key] instanceof SwitchElement) {
                    BaseView.Foreground = this.childs[key];
                    this.foregroundContainer.addChild(BaseView.Foreground);
                }

                if (key === "Logo" && this.childs[key] instanceof SwitchElement) {
                    BaseView.Logo = this.childs[key];
                    this.logoContainer.addChild(BaseView.Logo);
                }
            }

            if (DEBUG) {
                if (this._paylines == null) {
                    this.log("WARNING no paylines");
                }

                if (this._symbols == null) {
                    this.log("ERROR no symbols");
                }

                if (this._machine == null) {
                    this.log("ERROR no machine");
                }

                if (this._winAnimator == null) {
                    this.log("WARNING no winAnimator");
                }
            }
        }
    }

    disableLogo(): void {
        if (this.childs["LogoContainer"] != null) {
            this.removeChild(this.childs["LogoContainer"]);
        }
    }

    initReceived(controller: BaseController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.baseResponse != null) {
                    if (GameManager.baseResponse.initData != null && GameManager.baseResponse.initData.reels != null) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.initialize(
                            this._symbols,
                            GameManager.baseResponse.initData.reels,
                            this._teasingExtended,
                            this.teasingFS,
                            this.teasingBonus,
                            this.specialMachine,
                        );
                    }

                    if (
                        GameManager.baseResponse.screen != null &&
                        GameManager.baseResponse.screen.reels != null &&
                        GameManager.baseResponse.screen.reels.length !== 0
                    ) {
                        if (this._winAnimator != null) {
                            this._winAnimator.on(
                                WinAnimator.FinishWinCalculation,
                                this.finishWinCalculation.bind(this),
                            );
                            this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                            this._winAnimator.initialize(
                                this._symbols,
                                this._paylines,
                                this.childs["NoWinContainer"],
                                this.childs["WinContainer"],
                                this._teasingExtended,
                                this.teasingFS,
                                this.teasingBonus,
                                this.winframes,
                            );
                            this._winAnimator.showSymbols(GameManager.baseResponse.screen.reels);
                        }

                        this._machine.setStoppedSymbolsArray(GameManager.baseResponse.screen.reels);

                        if (ModuleManager.gambleActive()) {
                            BaseView.Background.goToCase("GAMBLE");
                            BaseView.MachineTop.goToCase("GAMBLE");
                            BaseView.FireFlies.goToCase("FS");
                            this.childs["Leafs"].alpha = 0;
                            this.childs["PaylinesContainer"].alpha = 0;
                            this.childs["WinContainer"].alpha = 0;
                        }
                    } else {
                        if (DEBUG) {
                            this.log("ERROR no reels in response");
                        }
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no base reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }
        if (ModuleManager.gambleActive()) {
            this.visible = true;
        } else {
            this.visible = false;
        }
    }

    initIntro(): void {
        StageController.baseStage = true;
        StageController.freespinStage = false;
        StageController.pickStageContainer.visible = false;
        StageController.freespinsStageContainer.visible = false;
        this.visible = true;

        this.fireflies.addChild(BaseView.FireFlies);
        this.background.addChild(BaseView.Background);
        this.machineTop.addChild(BaseView.MachineTop);
        this.paylinesContainer.addChild(BaseView.PaylinesContainer);
        this.messageContainer.addChild(BaseView.Message);
        this.transitionScreenContainer.addChild(BaseView.TransitionScreen);
        this.jackContainer.addChild(BaseView.Jack);
        this.logoContainer.addChild(BaseView.Logo);

        BaseView.FireFlies.goToCase("BASE");
        BaseView.MachineTop.goToCase("BASE");
        BaseView.Logo.goToCase("BASE");

        this._winAnimator.showInitWins(GameManager.baseResponse.wins, GameManager.baseResponse.currentWin);
        if (GameManager.gameResponse.totalWin > 0 || ModuleManager.freespinsEnabled() || ModuleManager.pickEnabled()) {
            this.setChildIndex(this.machineTop, this.getChildIndex(this.winframes));

            if (GameManager.gameResponse.totalWin > 0) {
                PlayList.loop("SND_BaseRecapLoop");
            }
            if (ModuleManager.freespinsEnabled()) {
                BaseView.Jack.goToCase("BASE_WAITING");
                this._winAnimator.startIdleJack();
                PlayList.stop("SND_BaseRecapLoop");
            }

            if (ModuleManager.pickEnabled()) {
                BaseView.Background.goToCase("BASE_WAITING");
                BaseView.Jack.goToCase("BASE_WAITING");
                this._winAnimator.startIdleJack();
                PlayList.stop("SND_BaseRecapLoop");
            }
        } else {
            PlayList.loop("SND_BaseLoop");
            this.setChildIndex(this.machineTop, this.getChildIndex(this.childs["LogoContainer"]) - 1);
        }

        if (ModuleManager.gambleActive()) {
        }
    }

    collect(): void {
        PlayList.stop("SND_BaseRecapLoop");
        PlayList.loop("SND_BaseLoop");

        Tweens.removeTweens(this.childs["PaylinesContainer"]);
        Tweens.removeTweens(this.childs["WinContainer"]);
        Tweens.removeTweens(this.childs["NoWinContainer"]);
        Tweens.removeTweens(this.childs["WinFrames"]);
        this.childs["PaylinesContainer"].scale.x = 1;
        this.childs["PaylinesContainer"].scale.y = 1;
        this.childs["WinContainer"].scale.x = 1;
        this.childs["WinContainer"].scale.y = 1;
        this.childs["NoWinContainer"].scale.x = 1;
        this.childs["NoWinContainer"].scale.y = 1;
        this.childs["WinFrames"].scale.x = 1;
        this.childs["WinFrames"].scale.y = 1;

        this._winAnimator.reset(true);
        this.setChildIndex(this.machineTop, this.getChildIndex(this.childs["LogoContainer"]) - 1);
    }

    spin(): void {
        StageController.baseStage = true;
        StageController.freespinStage = false;

        PlayList.stop("SND_BaseRecapLoop");
        PlayList.loop("SND_BaseLoop");
        Tweens.removeTweens(this.childs["PaylinesContainer"]);
        Tweens.removeTweens(this.childs["WinContainer"]);
        Tweens.removeTweens(this.childs["NoWinContainer"]);
        Tweens.removeTweens(this.childs["WinFrames"]);
        this.childs["PaylinesContainer"].scale.x = 1;
        this.childs["PaylinesContainer"].scale.y = 1;
        this.childs["PaylinesContainer"].alpha = 1;
        this.childs["WinContainer"].scale.x = 1;
        this.childs["WinContainer"].scale.y = 1;
        this.childs["WinContainer"].alpha = 1;
        this.childs["NoWinContainer"].scale.x = 1;
        this.childs["NoWinContainer"].scale.y = 1;
        this.childs["NoWinContainer"].alpha = 1;
        this.childs["WinFrames"].scale.x = 1;
        this.childs["WinFrames"].scale.y = 1;
        this.childs["WinFrames"].alpha = 1;

        this.isForce = false;

        let isHighWin = this._winAnimator.reset(true, true);

        if (isHighWin) {
            this._controller.isHighWin();
        }

        this._machine.spinStart(isHighWin, true, this._winAnimator.currentSymbols);

        this.setChildIndex(this.machineTop, this.getChildIndex(this.childs["LogoContainer"]) - 1);
    }

    stop(): void {
        this._machine.spinStop(null, true);
        this.isForce = true;
    }

    spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.baseResponse.screen.reels);

        this._machine.spinStop(null, false, true);
    }

    onReelStopped(): void {
        this._winAnimator.onReelStopped(
            GameManager.baseResponse.screen.reels,
            this._machine.actualReelStopped,
            this.isForce,
        );
    }

    machineStopped(): void {
        this._wasFinished = false;
        this._controller.machineStopped();

        this.jackContainer.addChild(BaseView.Jack);

        if (this._winAnimator.showWins(GameManager.baseResponse.wins, GameManager.baseResponse.currentWin)) {
            PlayList.stop("SND_BaseLoop");

            let tweenValues: Array<number> = this.formatTweenValues("scale.x", ArrayUtils.stringArray("1;1;0.85"));
            let tweenDuration: Array<number> = ArrayUtils.numberArray("60;60");
            let tweenEase: Array<string> = ArrayUtils.stringArray("linear;backInOut");
            let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

            Tweens.removeTweens(this.childs["PaylinesContainer"], "scale.x");
            Tweens.customTween(this.childs["PaylinesContainer"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1;0.85"));
            Tweens.removeTweens(this.childs["PaylinesContainer"], "scale.y");
            Tweens.customTween(this.childs["PaylinesContainer"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1;0.85"));
            Tweens.removeTweens(this.childs["WinContainer"], "scale.x");
            Tweens.customTween(this.childs["WinContainer"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1;0.85"));
            Tweens.removeTweens(this.childs["WinContainer"], "scale.y");
            Tweens.customTween(this.childs["WinContainer"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1;0.85"));
            Tweens.removeTweens(this.childs["NoWinContainer"], "scale.x");
            Tweens.customTween(this.childs["NoWinContainer"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1;0.85"));
            Tweens.removeTweens(this.childs["NoWinContainer"], "scale.y");
            Tweens.customTween(this.childs["NoWinContainer"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1;0.85"));
            Tweens.removeTweens(this.childs["WinFrames"], "scale.x");
            Tweens.customTween(this.childs["WinFrames"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("1;1;0.85"));
            Tweens.removeTweens(this.childs["WinFrames"], "scale.y");
            Tweens.customTween(this.childs["WinFrames"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });
        }

        if (GameManager.baseResponse.wins.length > 0) {
            this.setChildIndex(this.machineTop, this.getChildIndex(this.winframes));
        } else {
            PlayList.loop("SND_BaseLoop");
        }
    }

    finishWinCalculation(): void {
        this._wasFinished = true;

        this._controller.winCalculationFinished();

        if (this._winAnimator.getAnimationIndex() >= 3) {
            this._changeJackDelay.start(120);

            let tweenValues: Array<number> = this.formatTweenValues("scale.x", ArrayUtils.stringArray("0.75;1"));
            let tweenDuration: Array<number> = ArrayUtils.numberArray("30");
            let tweenEase: Array<string> = ArrayUtils.stringArray("backInOut");
            let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

            Tweens.removeTweens(this.childs["PaylinesContainer"], "scale.x");
            Tweens.customTween(this.childs["PaylinesContainer"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("0.75;1"));
            Tweens.removeTweens(this.childs["PaylinesContainer"], "scale.y");
            Tweens.customTween(this.childs["PaylinesContainer"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("0.75;1"));
            Tweens.removeTweens(this.childs["WinContainer"], "scale.x");
            Tweens.customTween(this.childs["WinContainer"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("0.75;1"));
            Tweens.removeTweens(this.childs["WinContainer"], "scale.y");
            Tweens.customTween(this.childs["WinContainer"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("0.75;1"));
            Tweens.removeTweens(this.childs["NoWinContainer"], "scale.x");
            Tweens.customTween(this.childs["NoWinContainer"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("0.75;1"));
            Tweens.removeTweens(this.childs["NoWinContainer"], "scale.y");
            Tweens.customTween(this.childs["NoWinContainer"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("0.75;1"));
            Tweens.removeTweens(this.childs["WinFrames"], "scale.x");
            Tweens.customTween(this.childs["WinFrames"], {
                tween: "scale.x",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            tweenValues = this.formatTweenValues("scale.y", ArrayUtils.stringArray("0.75;1"));
            Tweens.removeTweens(this.childs["WinFrames"], "scale.y");
            Tweens.customTween(this.childs["WinFrames"], {
                tween: "scale.y",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });
        }
    }

    changeJackDelay(): void {
        if (ModuleManager.freespinsEnabled() || ModuleManager.pickEnabled()) {
            this.jackContainer.addChild(BaseView.Jack);
        } else {
            BaseView.Jack.goToCase("HIGH_WIN_LEAVE");
        }
    }

    finishWinAnimator(): void {
        if (!DataManager.Autoplay || ModuleManager.freespinsEnabled() || ModuleManager.pickEnabled()) {
            PlayList.stop("SND_BaseLoop");
            PlayList.loop("SND_BaseRecapLoop");

            if (ModuleManager.freespinsEnabled()) {
                PlayList.stop("SND_BaseRecapLoop");

                if (BaseView.Jack.getCurrentCase().indexOf("HIGH_WIN") == -1) {
                    BaseView.Jack.goToCase("BASE_INCOME");
                }
                this._winAnimator.startIdleJack();
            }

            if (ModuleManager.pickEnabled()) {
                PlayList.stop("SND_BaseRecapLoop");

                if (BaseView.Jack.getCurrentCase().indexOf("HIGH_WIN") == -1) {
                    BaseView.Jack.goToCase("BASE_INCOME");
                }
                this._winAnimator.startIdleJack();
            }
        }

        this._controller.allWinsFinished();
    }

    resetWinAnimator(): void {
        this._winAnimator.reset(true);

        this.setChildIndex(this.machineTop, this.getChildIndex(this.childs["LogoContainer"]) - 1);
    }

    intro(long: boolean = false): void {
        StageController.baseStage = true;
        StageController.pickStageContainer.visible = false;
        StageController.freespinsStageContainer.visible = false;
        StageController.baseStageContainer.visible = true;
        this.visible = true;
        if (long) {
            this._winAnimator.showSymbols(GameManager.baseResponse.screen.reels);
            this._machine.setStoppedSymbolsArray(GameManager.baseResponse.screen.reels);
            this.setChildIndex(this.machineTop, this.getChildIndex(this.childs["LogoContainer"]) - 1);
            this._winAnimator.reset(true);

            this.background.addChild(BaseView.Background);
            this.fireflies.addChild(BaseView.FireFlies);
            this.machineTop.addChild(BaseView.MachineTop);
            this.paylinesContainer.addChild(BaseView.PaylinesContainer);
            this.messageContainer.addChild(BaseView.Message);
            this.transitionScreenContainer.addChild(BaseView.TransitionScreen);
            this.jackContainer.addChild(BaseView.Jack);
            this.foregroundContainer.addChild(BaseView.Foreground);
            this.logoContainer.addChild(BaseView.Logo);

            // BaseView.Logo.goToCase('BASE_SHOW');
            BaseView.Jack.goToCase("HIDE");
            // BaseView.MachineTop.goToCase('TO_BASE');

            let tweenValues: Array<number> = this.formatTweenValues("alpha", ArrayUtils.stringArray("0;0;1"));
            let tweenDuration: Array<number> = ArrayUtils.numberArray("30;60");
            let tweenEase: Array<string> = ArrayUtils.stringArray("linear");
            let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

            Tweens.removeTweens(this.childs["WinContainer"], "all");
            tweenDuration = [30, 30];
            tweenValues = this.formatTweenValues("alpha", ArrayUtils.stringArray("0;0;1"));
            Tweens.customTween(this.childs["WinContainer"], {
                tween: "alpha",
                tweenValues,
                tweenEase,
                tweenDuration,
                tweenDelay,
                tweenLoop: false,
            });

            if (BaseView.OutroFrom == "BONUS") {
                BaseView.Logo.goToCase("BASE_SHOW");
                tweenValues = this.formatTweenValues("alpha", ArrayUtils.stringArray("0;0;1"));
                Tweens.customTween(this.childs["PaylinesContainer"], {
                    tween: "alpha",
                    tweenValues,
                    tweenEase,
                    tweenDuration,
                    tweenDelay,
                    tweenLoop: false,
                });
                BaseView.PaylinesContainer.goToCase("EMPTY");
                this.childs["Leafs"].start();
            } else if (BaseView.OutroFrom == "FS") {
                this.childs["Leafs"].start();
                BaseView.Logo.goToCase("BASE_SHOW");
                BaseView.PaylinesContainer.goToCase("EMPTY");
            }

            BaseView.OutroFrom = "BASE";

            this._introDelay.start(60);
        } else {
            if (BaseView.OutroFrom == "GAMBLE") {
                BaseView.Background.goToCase("FROM_GAMBLE_TO_BASE");
                BaseView.FireFlies.goToCase("TO_BASE");
                BaseView.MachineTop.goToCase("FROM_GAMBLE_TO_BASE");

                let tweenValues: Array<number> = this.formatTweenValues("alpha", ArrayUtils.stringArray("0;0;1"));
                let tweenDuration: Array<number> = ArrayUtils.numberArray("30;60");
                let tweenEase: Array<string> = ArrayUtils.stringArray("linear");
                let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

                this.childs["WinContainer"].scale.x = 1;
                this.childs["WinContainer"].scale.y = 1;
                this.childs["NoWinContainer"].scale.x = 1;
                this.childs["NoWinContainer"].scale.y = 1;
                this.childs["PaylinesContainer"].scale.x = 1;
                this.childs["PaylinesContainer"].scale.y = 1;
                this.childs["WinFrames"].scale.x = 1;
                this.childs["WinFrames"].scale.y = 1;

                Tweens.removeTweens(this.childs["WinContainer"], "all");
                tweenDuration = [30];
                tweenValues = this.formatTweenValues("alpha", ArrayUtils.stringArray("0;1"));
                Tweens.customTween(this.childs["WinContainer"], {
                    tween: "alpha",
                    tweenValues,
                    tweenEase,
                    tweenDuration,
                    tweenDelay,
                    tweenLoop: false,
                });

                Tweens.removeTweens(this.childs["PaylinesContainer"], "all");
                tweenDuration = [30];
                tweenValues = this.formatTweenValues("alpha", ArrayUtils.stringArray("0;1"));
                Tweens.customTween(this.childs["PaylinesContainer"], {
                    tween: "alpha",
                    tweenValues,
                    tweenEase,
                    tweenDuration,
                    tweenDelay,
                    tweenLoop: false,
                });
                this._introDelay.start(30);
            } else {
                this.introFinished();
            }
        }
    }

    introFinished(): void {
        StageController.baseStage = true;
        BaseView.PaylinesContainer.goToCase("NORMAL");
        PlayList.stop("SND_FSEndLoop");

        if (GameManager.gameResponse.totalWin > 0) {
            PlayList.stop("SND_BaseLoop");
            PlayList.loop("SND_BaseRecapLoop");
        } else {
            PlayList.stop("SND_BaseRecapLoop");
            PlayList.loop("SND_BaseLoop");
        }

        PlayList.stop("SND_FSWait");

        this._winAnimator.alpha = 1;

        this._controller.introFinished();
    }

    outro(): void {
        StageController.baseStage = true;

        PlayList.stop("SND_BaseLoop");
        PlayList.stop("SND_BaseRecapLoop");
        PlayList.stop("SND_FSWinLoop");

        BaseView.OutroFrom = "BASE";

        if (ModuleManager.pickActive()) {
            BaseView.Logo.goToCase("BASE_HIDE");

            let tweenValues: Array<number> = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;1;0"));
            let tweenDuration: Array<number> = ArrayUtils.numberArray("30;60");
            let tweenEase: Array<string> = ArrayUtils.stringArray("linear");
            let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

            Tweens.removeTweens(this.childs["WinContainer"], "all");
            tweenValues = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;1;0"));
            Tweens.customTween(this.childs["WinContainer"], {
                tween: "alpha",
                tweenValues,
                tweenEase,
                tweenDuration: [30, 30],
                tweenDelay,
                tweenLoop: false,
            });
        }

        if (ModuleManager.freespinsActive()) {
            BaseView.Logo.goToCase("BASE_HIDE");
            PlayList.play("SND_FSTransIn");
            this._winAnimator.stopTimer();
            this._outroDelay.start(15);
        } else {
            const inHighWins = this._winAnimator.reset(true);

            this.setChildIndex(this.machineTop, this.getChildIndex(this.childs["LogoContainer"]) - 1);

            if (this._wasFinished) {
                if (ModuleManager.gambleActive()) {
                    this.toGambleTransition();
                    this._outroDelay.start(30);
                } else {
                    this.outroFinished();
                }
            } else {
                if (inHighWins) {
                    if (ModuleManager.gambleActive()) {
                        this._toGambleDelay.start(105);
                    }
                    this._outroDelay.start(120);
                } else {
                    if (ModuleManager.gambleActive()) {
                        this._toGambleDelay.start(45);
                    }
                    this._outroDelay.start(60);
                }
            }
        }
    }

    toGambleTransition(): void {
        PlayList.play("SND_transitionIn");
        BaseView.Background.goToCase("TO_GAMBLE");
        BaseView.FireFlies.goToCase("TO_FS");
        BaseView.MachineTop.goToCase("TO_GAMBLE");

        let tweenValues: Array<number> = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;0"));
        let tweenDuration: Array<number> = ArrayUtils.numberArray("15");
        let tweenEase: Array<string> = ArrayUtils.stringArray("linear");
        let tweenDelay: Array<number> = ArrayUtils.numberArray("0");

        Tweens.removeTweens(this.childs["WinContainer"], "all");
        Tweens.customTween(this.childs["WinContainer"], {
            tween: "alpha",
            tweenValues,
            tweenEase,
            tweenDuration,
            tweenDelay,
            tweenLoop: false,
        });

        Tweens.removeTweens(this.childs["PaylinesContainer"], "all");
        tweenValues = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;0"));
        tweenDuration = [15];
        Tweens.customTween(this.childs["PaylinesContainer"], {
            tween: "alpha",
            tweenValues,
            tweenEase,
            tweenDuration,
            tweenDelay,
            tweenLoop: false,
        });

        Tweens.removeTweens(this.childs["Leafs"], "all");
        tweenValues = this.formatTweenValues("alpha", ArrayUtils.stringArray("1;0"));
        tweenDuration = [15];
        Tweens.customTween(this.childs["Leafs"], {
            tween: "alpha",
            tweenValues,
            tweenEase,
            tweenDuration,
            tweenDelay,
            tweenLoop: false,
        });
    }

    outroFinished(): void {
        if (ModuleManager.gambleActive()) {
            StageController.baseStage = true;
        } else {
            StageController.baseStage = false;
        }

        if (ModuleManager.freespinsActive()) {
            this.childs["Leafs"].stop();
        } else if (ModuleManager.pickActive()) {
            this.childs["Leafs"].stopping();
        }
        this._controller.outroFinished();
    }

    selectPayline(id?: number): void {
        // if (this._paylinesSelector != null) {
        //     this._paylinesSelector.select(id);
        // }
    }

    disableBase(): void {
        this._winAnimator.resetTimer();
    }

    /**
     * Toggle all sounds used in base game (background, effects, .etc)
     * @param enable
     */
    toggleSounds(enable: boolean): void {
        if (enable) {
            PlayList.loop("SND_BaseLoop");
        } else {
            PlayList.stop("SND_BaseLoop");
            PlayList.stop("SND_BaseRecapLoop");
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Base/BaseView.ts
 **/